// Пустая рабочая область: «продуктов нет» говорим только когда их правда нет, иначе просим выбрать.
export function hostEmptyKeys(hasProducts) {
    return hasProducts
        ? { title: "shell.host.pick_title", description: "shell.host.pick_description" }
        : { title: "shell.host.empty_title", description: "shell.host.empty_description" };
}
